// extracted by mini-css-extract-plugin
export default {"photo":"MinerPhoto_photo__xrss6"};